import { render } from "./SigninView.vue?vue&type=template&id=1c5e040d"
import script from "./SigninView.vue?vue&type=script&lang=js"
export * from "./SigninView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__